import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  class: "dialog-footer"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取 消");

import { useVModel } from '@vueuse/core';
export default /*#__PURE__*/_defineComponent({
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  emits: ['update:isShow'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const showDialog = useVModel(props, 'isShow', emit);

    const handlerClose = () => {
      showDialog.value = false;
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_ElDialog = _resolveComponent("ElDialog");

      return _unref(showDialog) ? (_openBlock(), _createBlock(_component_ElDialog, {
        key: 0,
        title: "查看详情",
        modelValue: _unref(showDialog),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(showDialog) ? showDialog.value = $event : null),
        width: 620,
        "before-close": handlerClose,
        "destroy-on-close": "",
        "custom-class": "more-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handlerClose
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", {
          innerHTML: __props.content
        }, null, 8, _hoisted_1)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true);
    };
  }

});